<script setup>
	import { computed, defineProps } from 'vue'
	import Progress from './Progress.vue'
	import { advertiserMapping } from '../constants/selectOptions.js'

	const props = defineProps({
		progressPercent: {
			type: Number,
			default: '10'
		},
		showProgress: {
			type: Boolean
		},
		backButtonVisible: {
			type: Boolean
		},
		advertiser: {
			type: String
		},
		showDisclaimer: {
			type: Boolean
		}
	})
	const emit = defineEmits(['goBack','showTrackingDisclosure'])

	function getBrandFromDomain() {
		const hostname = window.location.hostname;

		if (hostname.includes('newleaffinancial.org')) return 'newleaf';
		if (hostname.includes('freshstartadvantage.org')) return 'freshstart';
		if (hostname.includes('horizondebtpartners.com')) return 'horizon';
		if (hostname.includes('brightpathrelief.com')) return 'brightpath';

		return 'logo';
	}

	function getPrettyNameFromDomain() {
		const hostname = window.location.hostname;
		let prettyTitle = 'First Advantage Financial';
		let metaDescription = 'Apply for debt relief with First Advantage Financial. Our online platform offers personalized solutions to help you regain financial stability.';


		if (hostname.includes('newleaffinancial.org')) {
			prettyTitle = 'Newleaf Financial';
			metaDescription = 'Apply for debt relief with Newleaf Financial. Our online platform offers personalized solutions to help you regain financial stability.';
		}
		if (hostname.includes('freshstartadvantage.org')) {
			prettyTitle = 'Fresh Start Advantage';
			metaDescription = 'Apply for debt relief with Fresh Start Advantage. Our online platform offers personalized solutions to help you regain financial stability.';
		}
		if (hostname.includes('horizondebtpartners.com')) {
			prettyTitle = 'Horizon Debt Partners';
			metaDescription = 'Apply for debt relief with Horizon Debt Partners. Our online platform offers personalized solutions to help you regain financial stability.';
		}
		if (hostname.includes('brightpathrelief.com')) {
			prettyTitle = 'Bright Path Relief';
			metaDescription = 'Apply for debt relief with Bright Path Relief. Our online platform offers personalized solutions to help you regain financial stability.';
		}

		document.title = prettyTitle;
		document.querySelector('meta[name="description"]').setAttribute('content', metaDescription);

		return prettyTitle;
	}

	const brand = getBrandFromDomain();
	const prettyName = getPrettyNameFromDomain();
	const logoUrl = computed(() => {
		return advertiserMapping[props.advertiser] ? advertiserMapping[props.advertiser].url : brand
	})

	const logoUrlString = computed(() => {
		return 'https://assets.firstadvantage.io/' + logoUrl.value + '.png'
	})
</script>

<template>
	<header class="container-fluid header-container" id="header">
		<div class="row justify-content-between">
			<div class="col align-self-center">
				<img 
					:src="logoUrlString"
					:alt="prettyName"
					class="img-fluid logo"
					width="120"
					height="66">
			</div>
			<div class="col align-self-end">
				<p v-if="showDisclaimer" class="header-disclosure"><span @click="$emit('showTrackingDisclosure')" class="pointer">Advertisement Disclaimer</span></p>
			</div>
		</div>
		<a role="button" tabindex="0" class="back back-desktop" v-if="showProgress && backButtonVisible" @click="$emit('goBack')"><i class="fa-solid fa-arrow-left"></i> Back</a>
	</header>
	<Progress v-if="showProgress" :progressPercent="progressPercent" />
</template>

<style scoped>
	.header-container {
		border-bottom: 1px solid #ccc;
		position: relative;
	}

	.logo {
		max-width: 120px;
		max-height: 77px;
		padding-top: 10px;
		padding-bottom: 10px;
	}

	.back {
		position: absolute;
		left: 15px;
		bottom: -33px;
		color: #ababab;
		font-weight: 600;
		cursor: pointer;
		display: none;
	}

	.back:hover {
		color: #19329a;
		background-color: transparent;
	}

	.header-disclosure {
		text-align: right;
		color: #c2c2c2;
		font-style: italic;
		font-size: 13px;
		margin: 0 0 5px 0;
	}

	.pointer {
		cursor: pointer;
	}

	@media (min-width: 550px) {
		.logo {
			max-width: 140px;
		}

		.back {
			display: block;
		}
	}
</style>
